import Skeleton from 'components/3catinfo/Skeleton';
import clsx from 'clsx';
import styles from './posterReel.module.scss';

const PosterReelSkeleton = (props) => {
    const { style } = props;

    const stylePoster = clsx({
        [styles.hasHover]: true,
        [styles.poster]: true
    });

    return (
        <div style={{ ...style }} className={`${stylePoster}`}>
            <div className={styles.wrapperSkeleton}>
                <Skeleton imatge className={styles.imatge} />
            </div>
        </div>
    );
};

export default PosterReelSkeleton;
